import * as React from "react";
import { inject } from "mobx-react";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { UitkTypeahead, ESSAdapter, TypeaheadRenderType } from "uitk-react-typeahead";
import { LocationFieldProps } from "./typings";
import { EssClientLogger } from "typeahead-client-logger";
import { ClientLogger } from "bernie-client";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { ACTION_CLOSE, ACTION_OPEN } from "utils/TrackingUtils";

export const LocationField: React.FunctionComponent<LocationFieldProps> = inject(
  "routeStore",
  "analytics"
)(
  ({
    analytics,
    config,
    context,
    essAdapterConfig,
    icon,
    invalid,
    label,
    location,
    name,
    onClick,
    onUpdate,
    routeStore,
    setInputsRefs,
    stid,
    track,
    trackId,
    typeaheadEmptyResultPlaceholder,
    typeaheadPlaceholder,
    value,
  }) => {
    if (!context || !routeStore) {
      // Check for injected stores
      return null;
    }

    const regionIdParam = config.queryParams && config.queryParams.regionId ? config.queryParams.regionId : "";
    const iataCodeParam = config.queryParams && config.queryParams.iataCode ? config.queryParams.iataCode : "";
    const latLongParam = config.queryParams && config.queryParams.latLong ? config.queryParams.latLong : "";
    const countryCodeParam = config.queryParams && config.queryParams.countryCode ? config.queryParams.countryCode : "";
    const pwaDialogQueryParam = config.pwaDialogQueryParam ? config.pwaDialogQueryParam : "";

    let essAdapterFeatures = essAdapterConfig.features;
    if (essAdapterFeatures.indexOf("consistent_display") < 0) {
      essAdapterFeatures += "|consistent_display";
    }

    const renderDialog = (children: JSX.Element) => {
      return (
        <QueryRoute query={{ pwaDialog: pwaDialogQueryParam }}>
          <Layer id={`${stid}-ta-dialog`}>{children}</Layer>
        </QueryRoute>
      );
    };

    const open = (renderType: string) => {
      if (renderType === TypeaheadRenderType.DIALOG) {
        routeStore.updateSearch({
          pwaDialog: pwaDialogQueryParam,
        });
      }

      if (typeof onClick === "function") {
        onClick();
      }

      if (track) {
        track(trackId + ACTION_OPEN);
      }
    };

    const close = (renderType: string) => {
      if (renderType === TypeaheadRenderType.DIALOG) {
        routeStore.goBack();
      }
      if (track) {
        track(trackId + ACTION_CLOSE);
      }
    };

    const essAnalyticsLogger = new EssClientLogger(
      analytics,
      ClientLogger,
      location.value,
      (context as ExtendedContextStore)?.experimentContext?.experiments
    );

    const onClear = () => {
      location.value = "";
    };

    const lastSearchElapseTime = location.metaData.lastSearchTimestamp
      ? Math.floor(Date.now() / 1000) - location.metaData.lastSearchTimestamp
      : undefined;

    return (
      <div data-testid={`${stid}-container`}>
        <UitkTypeahead
          adapter={
            new ESSAdapter({
              client: essAdapterConfig.client,
              dest: essAdapterConfig.dest,
              expuserid: context.user.expUserId,
              features: essAdapterFeatures,
              guid: context.guid,
              inputId: stid,
              lob: essAdapterConfig.lob,
              locale: context.locale,
              maxResults: essAdapterConfig.maxResults,
              regionType: essAdapterConfig.regionType,
              siteId: context.site.id,
              regionId: essAdapterConfig.regionId,
              domain: "/",
              enableEgta: essAdapterConfig.egtaExperimentEnabled,
              essLogger: essAnalyticsLogger,
              personalize: true,
              packageType: essAdapterConfig.packageType,
              lastSearchLatLong: location.metaData.lastSearchLatLong,
              lastSearchElapseTime,
            })
          }
          onMountCB={setInputsRefs}
          onClick={open}
          onDismiss={close}
          onUpdate={onUpdate}
          renderDialog={renderDialog}
          hasClearButton={false}
          handleClear={onClear}
          allowExactMatch={true}
          icon={icon}
          name={name}
          label={label}
          invalid={invalid}
          value={value}
          stid={stid}
          typeaheadPlaceholder={typeaheadPlaceholder}
          typeaheadEmptyResultPlaceholder={typeaheadEmptyResultPlaceholder}
        />

        {regionIdParam && location.metaData.regionId && (
          <input type="hidden" name={regionIdParam} value={location.metaData.regionId} />
        )}
        {iataCodeParam && location.metaData.ttla && (
          <input type="hidden" name={iataCodeParam} value={location.metaData.ttla} />
        )}
        {latLongParam && location.metaData.latLong && (
          <input type="hidden" name={latLongParam} value={location.metaData.latLong} />
        )}
        {countryCodeParam && location.metaData.countryCode && (
          <input type="hidden" name={countryCodeParam} value={location.metaData.countryCode} />
        )}
      </div>
    );
  }
);
